import Foods from "../../data/Foods";
import { IFoodAmount, type IRecipe } from "../../shared/Recipes";

function FoodRow(props:{food:IFoodAmount}) {
    const foodName = Foods.i.name(props.food.id)
    const amount = props.food.amount + " " + props.food.unit
    return <div className="row flex between gap-24">
        <label className="w700">{foodName}</label>
        <div className="nowrap">{amount}</div>
    </div>
}
export default function RecipeViewer(props:{recipe:IRecipe}) {
    const {recipe} = props
    const foods = recipe.foods.map(food => <FoodRow food={food} key={food.id}/>)
    return <div className="recipe">
        <p className="small-text">{recipe.description}</p>
        <div><label>Serves: </label>{recipe.servings}</div>
        <div className="foods">{foods}</div>
    </div>
}